export default __webpack_public_path__ + "static/media/add-small-icon.b331b855.svg";